module.exports = __webpack_public_path__ + "img/birthday.a714fdf7.svg";